(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calculate-shipping-panel"] && !Shopify.designMode) return;
  try {
    
(function() {
  var root = document.getElementById('calculate-shipping-panel');
  if (!root) return;
  console.log('Currency when calculating shipping:', window.activeCurrency);
  console.log('Active storefront currency:', activeCurrency);

  if (root.dataset.shippingPanelInitialized === 'true') return;
  root.dataset.shippingPanelInitialized = 'true';

  var panel = root.querySelector('.offcanvas__panel1');
  var lastFocused = null;

  // 🔹 Get references to inputs + button
  var postalInput  = root.querySelector('#shipping-postal-code');
  var cityInput    = root.querySelector('#shipping-city');
  var countryInput = root.querySelector('#shipping-country');
  var calculateBtn = root.querySelector('.button-calculate-panel');

  // 🔹 Utility: update button disabled state
  function updateButtonState() {
    if (!calculateBtn) return;

    var hasPostal  = postalInput && postalInput.value.trim() !== '';
    var hasCity    = cityInput && cityInput.value.trim() !== '';
    var hasCountry = countryInput && countryInput.value.trim() !== '';

    var enabled = hasPostal && hasCity && hasCountry;

    calculateBtn.disabled = !enabled;
  }

  // Initial state: disabled until fields filled
  updateButtonState();

  // Watch for user typing in fields
  ['input', 'change'].forEach(function(evtName) {
    if (postalInput)  postalInput.addEventListener(evtName, updateButtonState);
    if (cityInput)    cityInput.addEventListener(evtName, updateButtonState);
    if (countryInput) countryInput.addEventListener(evtName, updateButtonState);
  });

  function openPanel() {
    if (root.classList.contains('is-open')) return;
    lastFocused = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    if (panel) panel.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closePanel() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      closePanel();
    }
  }

  var overlay = root.querySelector('.offcanvas__overlay');
  if (overlay) overlay.addEventListener('click', closePanel);

  root.addEventListener('click', function(e) {
    if (e.target.closest('[data-offcanvas-close]')) {
      e.preventDefault();
      closePanel();
    }
  });

  // Open from link / trigger and store product data
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest(
      '[data-open-shipping], [data-calculate-shipping-open], a[href="#openCalculateShipping"]'
    );
    if (!trigger) {
      return;
    } 

    e.preventDefault();

    var kolli       = trigger.dataset.kolli;
    var productId   = trigger.dataset.productId;
    var productTitle = trigger.dataset.productTitle;
    var customLength = trigger.dataset.productLength;
    var customWidth = trigger.dataset.productWidth;

    console.log("FROM LINK:", kolli, productId, productTitle, customLength, customWidth);

    root.dataset.kolli = kolli;
    root.dataset.productId = productId;
    root.dataset.productTitle = productTitle;

    window.__shippingData__ = {
      kolli,
      productId,
      productTitle
    };

    openPanel();
  });

document.addEventListener('click', function(e) {
  const btn = e.target.closest('.button-calculate-panel');
  if (!btn) return;

  // If button is disabled, do nothing
  if (btn.disabled) {
    e.preventDefault();
    return;
  }

  console.log('root', root.dataset);

  // 1) Read address fields
  const city    = document.getElementById('shipping-city')?.value.trim() || '';
  const country = document.getElementById('shipping-country')?.value.trim() || '';
  const zipcode = document.getElementById('shipping-postal-code')?.value.trim() || '';
  const street  = document.getElementById('shipping-street')?.value.trim() || '';

  // 2) Read kolli from the panel dataset (set when opening)
  const kolliRaw = root.dataset.kolli || '';
  const customLength = root.dataset.customLength || '';
  const customWidth = root.dataset.customWidth || ''; 

  // Parse kolli "L*W*H" → numbers
  let length, width, height;

  if (typeof kolliRaw === 'string' && kolliRaw.includes('*')) {
    var parts = kolliRaw.split('*').map(function(x) { return parseInt(x, 10); });
    if (parts.length === 3 && parts.every(function(x) { return !isNaN(x); })) {
      length = parts[0];
      width  = parts[1];
      height = parts[2];
    }
  }

  console.log('City:', city);
  console.log('Country:', country);
  console.log('Zip:', zipcode);
  console.log('Kolli:', kolliRaw, '→', { length, width, height });

  // 3) Build UPS-style payload

  // Example static From-address
  var shipFrom = {
    Address: {
      AddressLine: ["Your Street 1"],
      City: "Malmo",
      StateProvinceCode: "",
      PostalCode: "21100",
      CountryCode: "SE"
    }
  };

  var shipTo = {
    Address: {
      AddressLine: [""],
      City: city,
      StateProvinceCode: "",
      PostalCode: zipcode,
      CountryCode: country // ideally ISO code, e.g. "SE"
    }
  };
  if (customLength){
    console.log('there is custom product length');
  }
  if (customWidth){
    console.log('there is custom product width');
  }
  // Length rounding formula
  var calculatedLength = 5 * Math.ceil((0.5 * length + 5) / 5);
  // HeightValue based on width
  var heightValue = width <= 150 ? "30" : "40";

  var pkg = {
    PackagingType: { Code: "02" },
    Dimensions: {
      UnitOfMeasurement: { Code: "CM" },
      Length: calculatedLength.toString(),
      Width: heightValue,
      Height: heightValue
    },
    PackageWeight: {
      UnitOfMeasurement: { Code: "KGS" },
      Weight: "5" // TODO: replace with real weight if you have it
    }
  };

  // You can hard-code or later pass serviceCode from data-attributes
  var serviceCode = "11"; // example service code

  var payload = {
    ShipFrom: shipFrom,
    ShipTo: shipTo,
    Package: [pkg],
    currency: "SEK",
    serviceCode: serviceCode,
    env: "Live",
    productId: root.dataset.productId,
    customLength: customLength,
    customWidth: customWidth,
  };

  var resultDiv = document.getElementById('shipping-result');
  if (!resultDiv) {
    // Create one on the fly if missing
    resultDiv = document.createElement('div');
    resultDiv.id = 'shipping-result';
    resultDiv.className = 'shipping-result';
    btn.parentNode.appendChild(resultDiv);
  }

  resultDiv.innerHTML = 'Calculating shipping...';

  fetch('https://backend-ups-rate.onrender.com/api/rate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
    .then(function(res) {
      if (!res.ok) {
        throw new Error('HTTP ' + res.status);
      }
      return res.json();
    })
.then(function(data) {
  console.log('UPS API response:', data);

  var ratedShipment = data && data.RateResponse && data.RateResponse.RatedShipment;
  // handle both array and object forms
  if (Array.isArray(ratedShipment)) {
    ratedShipment = ratedShipment[0];
  }
  var totalCharges = ratedShipment && ratedShipment.TotalCharges;
  var amount       = totalCharges && parseFloat(totalCharges.MonetaryValue);
  var currency     = totalCharges && totalCharges.CurrencyCode;

  // Fallback if UPS response is weird
   if (data === "Free Shipping") {
    resultDiv.innerHTML = '<strong>FREE SHIPPING FOR ALL CUSTOMERS IN EUROPE.</strong>';
    return;
  }

  if (!amount || !currency) {
    resultDiv.innerHTML = 'Estimated shipping1: ' + JSON.stringify(data);
    return;
  }

  // What currency does the storefront want to show?
  var activeCurrency = window.activeCurrency || currency;
  console.log('UPS amount:', amount, currency, ' → storefront currency:', activeCurrency);

  // If currencies already match, no need to convert
  if (activeCurrency === currency) {
    resultDiv.innerHTML = 'Estimated shipping: ' + amount.toFixed(2) + ' ' + currency;
    return;
  }

  // Otherwise, call your /convert endpoint
  fetch('https://backend-ups-rate.onrender.com/convert', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      originalValue: amount,
      originalCurrency: currency,
      newCurrency: activeCurrency
    })
  })
    .then(function(res) {
      if (!res.ok) {
        throw new Error('FX HTTP ' + res.status);
      }
      return res.json();
    })
    .then(function(conv) {
      console.log('FX conversion response:', conv);

    if (conv && conv.convertedValue && typeof conv.convertedValue.value === 'number') {
        resultDiv.innerHTML =
          'Estimated shipping: ' +
          conv.convertedValue.value.toFixed(2) + ' ' +
          conv.convertedValue.code;
      } else {
        // If conversion payload is unexpected, fall back to UPS amount
        resultDiv.innerHTML =
          'Estimated shipping: ' + amount.toFixed(2) + ' ' + currency;
      }
    })
    .catch(function(err) {
      console.error('Currency conversion failed:', err);
      // Fallback: still show original UPS amount in its currency
      resultDiv.innerHTML =
        'Estimated shipping: ' + amount.toFixed(2) + ' ' + currency;
    });
})
});

  if (window.location.hash === '#openCalculateShipping') openPanel();
    window.addEventListener('hashchange', function() {
      if (window.location.hash === '#openCalculateShipping') openPanel();
    });

  // ---------- Google Maps loader (inline, with importLibrary) ----------
  async function ensurePlaceAutocompleteElement() {
    if (!window.google || !google.maps || !google.maps.importLibrary) {
      (function(g) {
        const p = "The Google Maps JavaScript API";
        const c = "google";
        const l = "importLibrary";
        const q = "__ib__";
        const m = document;
        const b = g;
        const d = (b[c] ||= {});
        const maps = (d.maps ||= {});
        const s = new Set();
        const e = new URLSearchParams();
        let h;

        maps[l] = maps[l] || ((f, ...n) => {
          s.add(f);
          return (h ||= new Promise((resolve, reject) => {
            const script = m.createElement("script");
            e.set("key", "AIzaSyCasx30dVyh7Jth1KT_5B_RFzgAflYPn78"); // your real key here
            e.set("v", "weekly");
            e.set("libraries", [...s].join(","));
            e.set("callback", c + ".maps." + q);
            script.src = "https://maps.googleapis.com/maps/api/js?" + e.toString();
            maps[q] = resolve;
            script.onerror = () => reject(Error(p + " could not load."));
            script.nonce = m.querySelector("script[nonce]")?.nonce || "";
            m.head.append(script);
          })).then(() => maps[l](f, ...n));
        });
      })(window);
    }

    const { PlaceAutocompleteElement } = await google.maps.importLibrary('places');
    return PlaceAutocompleteElement;
  }

  // ---------- Shipping autocomplete init ----------
  async function initShippingAutocomplete() {
    var container = document.getElementById('shipping-address-autocomplete-container');
    if (!container) return;

    try {
      var PlaceAutocompleteElement = await ensurePlaceAutocompleteElement();

      var pac = new PlaceAutocompleteElement({
        // includedPrimaryTypes: ['street_address'],
        // includedRegionCodes: ['se']
      });

      container.appendChild(pac);

      pac.addEventListener('gmp-select', async function(event) {
        var placePrediction = event.placePrediction;
        if (!placePrediction || !placePrediction.toPlace) return;

        var place = placePrediction.toPlace();
        await place.fetchFields({ fields: ['addressComponents', 'formattedAddress'] });

        var components = {
          street_number: '',
          route: '',
          locality: '',
          postal_town: '',
          postal_code: '',
          country: ''
        };

        (place.addressComponents || []).forEach(function(c) {
          var type = c.types[0];
          if (components.hasOwnProperty(type)) {
            components[type] = c.longText || c.shortText || c.long_name || c.short_name;
          }
        });

        var streetInput  = document.getElementById('shipping-street');
        var cityInputEl    = document.getElementById('shipping-city');
        var postalInputEl  = document.getElementById('shipping-postal-code');
        var countryInputEl = document.getElementById('shipping-country');

        var cityValue = components.postal_town || components.locality;

        if (streetInput) {
          streetInput.value = (components.street_number + ' ' + components.route).trim();
        }
        if (cityInputEl) {
          cityInputEl.value = cityValue || '';
        }
        if (postalInputEl) {
          postalInputEl.value = components.postal_code || '';
        }
        if (countryInputEl) {
          countryInputEl.value = components.country || '';
        }

        // 🔹 After autocomplete fills fields, update button state
        updateButtonState();
      });
    } catch (err) {
      console.error('Failed to init Google Places autocomplete:', err);
    }
  }

  initShippingAutocomplete();

  window.calculateShippingPanel = openPanel;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {});

  document.addEventListener('DOMContentLoaded', () => {
    const desk = document.getElementById('product__main_desktop');
    const mob = document.getElementById('product__main_mobile');
    if (!desk || !mob) {
      console.warn('Toggle script: missing #product__main_desktop or #product__main_mobile');
      return;
    }

    const mq = window.matchMedia('(min-width: 768px)');

    function thumbNailsManager() {
      const thumbnails = document.querySelectorAll('.product__media-subitem');

      thumbnails.forEach((thumbnail) => {
        thumbnail.style.opacity = '1';
        thumbnail.addEventListener('click', function (e) {
          const mediaId = this.getAttribute('data-media-sub-id');
          if (!mediaId) return;

          const mainWrapper = document.querySelector('.product__media-list .swiper-wrapper');
          if (!mainWrapper) return;

          const mainSlide = mainWrapper.querySelector(`[data-media-id="${mediaId}"]`);
          if (mainSlide) {
            const swiperInstance = document.querySelector('.js-media-list.swiper')?.swiper;
            if (swiperInstance) {
              const index = Array.from(mainWrapper.children).indexOf(mainSlide);
              swiperInstance.slideTo(index);
            }
          }
        });
      });
    }

    function toggleView(e) {
      console.log('↔️ viewport change:', e.matches ? '▶️ desktop' : '📱 mobile');
      if (e.matches) {
        desk.style.display = 'contents';
        mob.style.display = 'none';
      } else {
        desk.style.display = 'none';
        mob.style.display = 'contents';
        thumbNailsManager();
      }
    }

    // Initial set
    toggleView(mq);

    // Modern API
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', toggleView);
    }
    // Fallback for Safari, older browsers
    else if (typeof mq.addListener === 'function') {
      mq.addListener(toggleView);
    }
  });

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }
      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["off-canvas-panel"] && !Shopify.designMode) return;
  try {
    
(function () {
  var loadedOnce = false;

  function escapeHTML(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
function normalizeProducts(data) {
  // Handle the new nested structure: { products: { category: [...] } }
  if (data && data.products && typeof data.products === 'object') {
    return data; // Return the whole structure for renderItems to handle
  }
  
  // Fallback for old structure
  if (Array.isArray(data)) return { products: { "Products": data } };
  if (data && Array.isArray(data.products)) return { products: { "Products": data.products } };
  
  return { products: {} };
}

function renderItems(listEl, data, max) {
  listEl.innerHTML = '';
  
  // Handle the new nested structure
  var products = data.products || {};
  var categories = Object.keys(products);
  
  if (categories.length === 0) {
    listEl.innerHTML = '<li class="offcanvas-product">No products found</li>';
    return;
  }
  
  var totalRendered = 0;
  var maxItems = max || 50; // Default max if not specified
  
  categories.forEach(function(categoryName) {
    if (totalRendered >= maxItems) return; // Stop if we've hit the limit
    
    var categoryProducts = products[categoryName] || [];
    if (categoryProducts.length === 0) return; // Skip empty categories
    
    // Create category header
    var categoryHeader = document.createElement('li');
    categoryHeader.className = 'offcanvas-category-header';
    categoryHeader.innerHTML = '<h3 class="offcanvas-category-title">' + escapeHTML(categoryName) + '</h3>';
    listEl.appendChild(categoryHeader);
    
    // Add products in this category
    var productsToShow = Math.min(categoryProducts.length, maxItems - totalRendered);
    
    for (var i = 0; i < productsToShow; i++) {
      var p = categoryProducts[i] || {};
      var title = p.title || 'Untitled';
      var sub = p.description || p.subtitle || '';
      var productId = p.id || p.product_id;
      
      var li = document.createElement('li');
      li.className = 'offcanvas-product';
      
      var linkEl = document.createElement('a');
      linkEl.href = '#';
      linkEl.className = 'offcanvas-product__link';
      linkEl.dataset.productId = productId;
      linkEl.innerHTML = 
        '<div class="offcanvas-product__info">' +
          '<div class="offcanvas-product__title">' + escapeHTML(title) + '</div>' +
          (sub ? '<div class="offcanvas-product__sub">' + escapeHTML(sub) + '</div>' : '') +
        '</div>';
      
      li.appendChild(linkEl);
      listEl.appendChild(li);
      totalRendered++;
      
      if (totalRendered >= maxItems) break;
    }
  });
  
  // Add event delegation for all product links (same as before)
  listEl.addEventListener('click', function(e) {
    var linkEl = e.target.closest('.offcanvas-product__link');
    if (linkEl) {
      e.preventDefault();
      var productId = linkEl.dataset.productId;
      
      if (productId && window.openProductCustomizer) {
        // Close the offcanvas panel properly
        var offcanvasRoot = document.getElementById('offcanvas-root');
        if (offcanvasRoot) {
          // Set aria-hidden to true to close the panel
          offcanvasRoot.setAttribute('aria-hidden', 'true');
          
          // Also trigger any existing close functionality
          var closeEvent = new Event('click');
          var overlay = offcanvasRoot.querySelector('.offcanvas__overlay');
          if (overlay) {
            overlay.dispatchEvent(closeEvent);
          }
          
          // Alternative: Find and click the close button
          var closeBtn = offcanvasRoot.querySelector('[data-offcanvas-close]');
          if (closeBtn) {
            closeBtn.click();
          }
        }
        
        // Small delay to ensure panel closes before opening modal
        setTimeout(function() {
          window.openProductCustomizer(productId);
        }, 100);
        
      } else {
        console.error('Product ID not found or customizer not available:', productId);
      }
    }
  });
}

function fetchAndRender() {
  if (loadedOnce) return;
  var root = document.getElementById('offcanvas-api-list');
  if (!root) return;

  var endpoint = root.dataset.endpoint;
  var max = parseInt(root.dataset.max || '0', 10) || 20;
  var listEl = root.querySelector('.offcanvas-products--api');
  var statusEl = root.querySelector('.offcanvas-api__status');
  var errEl = root.querySelector('.offcanvas-api__error');

  if (!endpoint) {
    if (statusEl) statusEl.textContent = 'Set an API endpoint in the section settings.';
    return;
  }

  loadedOnce = true; // prevent duplicate calls
  if (statusEl) { statusEl.hidden = false; statusEl.textContent = 'Loading products…'; }
  if (errEl) errEl.hidden = true;

  fetch(endpoint, { credentials: 'omit' })
    .then(function(r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    })
    .then(function(data) {
      var normalizedData = normalizeProducts(data);
      
      // Check if we have any categories with products
      var hasProducts = false;
      if (normalizedData.products) {
        var categories = Object.keys(normalizedData.products);
        for (var i = 0; i < categories.length; i++) {
          if (normalizedData.products[categories[i]].length > 0) {
            hasProducts = true;
            break;
          }
        }
      }
      
      if (!hasProducts) throw new Error('No products found in API response.');
      
      renderItems(listEl, normalizedData, max);
      if (statusEl) statusEl.hidden = true;
      if (listEl) listEl.hidden = false;
    })
    .catch(function(err) {
      if (statusEl) statusEl.hidden = true;
      if (errEl) { errEl.hidden = false; errEl.textContent = 'Failed to load products: ' + err.message; }
      loadedOnce = false; // allow retry if it failed
    });
}

  document.addEventListener('DOMContentLoaded', function() {
    var root = document.getElementById('offcanvas-api-list');
    if (root && root.dataset.endpoint) fetchAndRender();
  });
  document.addEventListener('shopify:section:load', fetchAndRender);
  document.addEventListener('shopify:section:select', fetchAndRender);

  var offcanvas = document.getElementById('offcanvas-root');
  if (offcanvas && 'MutationObserver' in window) {
    var obs = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'aria-hidden') {
          var val = offcanvas.getAttribute('aria-hidden');
          if (val === 'false') fetchAndRender();
        }
      });
    });
    obs.observe(offcanvas, { attributes: true });
  }

  document.addEventListener('click', function(e) {
    var openBtn = e.target.closest('[data-offcanvas-open]');
    if (openBtn) fetchAndRender();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
